export enum UserStatus {
  ACTIVE = "active",
  ASSIGNED = "assigned",
  UNASSIGNED = "unassigned",
  DELETED = "deleted",
  SUBSCRIPTION_FINISHED = "subscription_finished",
  TRANSFER_PENDING = "transfer_pending",
  RENEWAL_PENDING = "renewal_pending",
  CHANGE_REQUESTED = "change_requested",
  INACTIVE = "inactive",
}
